import DefaultProps from '../../commonTypes/defaultprops.types';
import Handler from '../../commonTypes/handler.types';

export interface CheckboxProps extends DefaultProps {
  /**
   * Text displayed in the pill
   */
  label: string;
  /**
   * Unique Identifier
   */
  id?: string;
  /**
   * Prefix used for generation of UID if no id passed
   */
  idPrefix?: string;
  /**
   * Checkbox name
   */
  name?: string;
  /**
   * The string to use as the value of the checkbox when submitting the form, if the checkbox is currently checked
   */
  value?: string;
  /**
   * When using as controlled component, indicates whether or not this checkbox is checked
   */
  checked?: boolean;
  /**
   * When using as uncontrolled component, indicates whether or not this checkbox is checked by default (when the page loads)
   */
  defaultChecked?: boolean;
  /**
   * Handlers that are attached
   */
  handlers?: Handler;
  /**
   * Which type of checkbox we're displaying, PILL or CHECKBOX
   */
  type?: CheckboxType;

  /**
   * Currently no need for supporting the following, but could come handy in the future:
   *   disabled?: boolean;
   *   required?: boolean;
   *   readonly?: boolean;
   */
}

export interface LabelProps {
  theme: {
    dark: boolean;
  };
  type?: CheckboxType;
}

export interface InputProps {
  theme: {
    dark: boolean;
  };
  checked?: boolean;
}

export enum CheckboxType {
  PILL = "pill",
  CHECKBOX = "checkbox"
}
